import { InstrumentDto } from 'src/store/instruments/instrument';
import { ArrayUtils } from 'src/utils/array';
import { InstrumentAction, InstrumentTypes } from './instruments.actions';

export type InstrumentsState = Readonly<{
  instruments: InstrumentDto[];
  errors: any;
}>;

const initialState: InstrumentsState = {
  instruments: [],
  errors: null
};

const instrumentsReducer = (
  state: InstrumentsState = initialState,
  action: InstrumentAction
) => {
  switch (action.type) {
    case InstrumentTypes.FetchAll:
      return { ...state, instruments: action.instruments };
    case InstrumentTypes.Add:
      return {
        ...state,
        instruments: [...state.instruments, action.instrument]
      };
    case InstrumentTypes.Update:
      return {
        ...state,
        instruments: ArrayUtils.updateListById(
          state.instruments,
          action.instrument
        )
      };
    case InstrumentTypes.Delete:
      return {
        ...state,
        instrument: null,
        instruments: ArrayUtils.deleteFromListById(
          state.instruments,
          action.instrument
        )
      };
    case InstrumentTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default instrumentsReducer;
